export default "__VITE_ASSET__Dy_M7XXr__"